module.exports = __webpack_public_path__ + "static/media/nat-8.14efd82b.jpg";